import { render, staticRenderFns } from "./PaymentStatusBackdrop.vue?vue&type=template&id=2e07cefc"
import script from "./PaymentStatusBackdrop.vue?vue&type=script&lang=js"
export * from "./PaymentStatusBackdrop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports